// extracted by mini-css-extract-plugin
var _1 = "ra-paragraph-center";
var _2 = "ra-paragraph";
var _3 = "ra-paragraph-level-1";
var _4 = "ra-paragraph-level-2";
var _5 = "ra-paragraph-level-3";
var _6 = "ra-paragraph-level-4";
var _7 = "ra-paragraph-level-5";
var _8 = "ra-paragraph-level-6";
var _9 = "ra-paragraph-normalcase";
var _a = "ra-paragraph-right";
var _b = "ra-paragraph-uppercase";
export { _1 as "paragraphCenterCls", _2 as "paragraphCls", _3 as "paragraphLevel1Cls", _4 as "paragraphLevel2Cls", _5 as "paragraphLevel3Cls", _6 as "paragraphLevel4Cls", _7 as "paragraphLevel5Cls", _8 as "paragraphLevel6Cls", _9 as "paragraphNormalCaseCls", _a as "paragraphRightCls", _b as "paragraphUpperCaseCls" }
